import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormsModule } from "@angular/forms";
import { CustomFormValidators } from "@shared/validators/custom-form-validators";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { SignGroup } from "@models/annual-statements/annual-statement-enums";
import { SignRow } from "@models/documents/sign-documents";
import {
  InputPhoneNumberComponent
} from "@shared/controls/input-phone-number/input-phone-number.component";

type ActionEvent = (data: unknown) => void;

type CellRendererParams = ICellRendererParams<SignRow> & {
  edit: ActionEvent;
  isRequired?: boolean;
};

@Component({
  selector: 'app-ag-annual-sign-edit-phone',
  standalone: true,
  imports: [
    InputPhoneNumberComponent,
    FormsModule
  ],
  templateUrl: 'ag-annual-sign-edit-phone.component.html',
  styleUrl: '../styles/ag-hidden-input.scss'
})
export class AgAnnualSignEditPhoneComponent implements ICellRendererAngularComp, AfterViewInit {
  @ViewChild('input', { read: ViewContainerRef }) input!: ViewContainerRef;

  params!: CellRendererParams;
  value: string | undefined;
  disabled = false;
  validationError = false;
  type: SignGroup | undefined;
  isRequired = false;

  ngAfterViewInit() {
    window.setTimeout(() => {
      if (this.input) {
        (this.input.element.nativeElement as Element).querySelector('input')?.focus();
      }
    });
  }

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.params = params;
    this.value = params.data?.phone ?? '';
    this.disabled = params.data?.disabled ?? false;
    this.type = params.data?.type;
    this.isRequired = params.isRequired ?? false;
    return true;
  }

  onChangeValue(value: string): void {
    this.params.edit({ value: value, index: this.params.node.rowIndex, column: 'phone' });
    this.validationError = !this.isPhoneValid(value);

    if (this.params.data) {
      this.params.data.phone = value;
    }
  }

  onFocus(): void {
    this.params.eGridCell.classList.add('ag-focused-cell');
  }

  onBlur(): void {
    this.params.eGridCell.classList.remove('ag-focused-cell');
  }

  private isPhoneValid(phone: string): boolean {
    const control = { value: phone } as AbstractControl;
    const errors = CustomFormValidators.phoneNumberValidator(control);

    if (!phone?.trim() && this.isRequired) return false;

    return errors === null;
  }

  get placeholder(): string {
    const placeholder = 'Enter mobile number';
    if (!this.isRequired) return placeholder;
    return placeholder + '*';
  }

  get isNotCarbonCopy(): boolean {
    return this.type != SignGroup.CarbonCopy;
  }
}
